import * as React from "react";

import { MetadataChangesetEditor } from "@/shared/components/Metadata";
import { Device } from "@/shared/domain/devices";
import { useUpdateDevice } from "@/shared/domain/devices/hooks/useUpdateDevice";

interface UpdateDeviceMetadataProps {
  device: Device;
  resourceOwnerId: string;
  readonly?: boolean;
  onMetadataUpdated?: (device: Device) => void;
  onError?: (error: Error) => void;
}

export const UpdateDeviceMetadata: React.FC<UpdateDeviceMetadataProps> = ({
  device,
  resourceOwnerId,
  readonly = false,
  onMetadataUpdated,
  onError,
}) => {
  const updateDeviceMutation = useUpdateDevice();

  return (
    <MetadataChangesetEditor
      metadata={device.metadata}
      recordKey={device.device_id}
      readonly={readonly}
      isPending={updateDeviceMutation.isPending}
      error={updateDeviceMutation.error}
      onDismissError={() => updateDeviceMutation.reset()}
      onChangeset={(changeset) =>
        updateDeviceMutation.mutate(
          {
            deviceId: device.device_id,
            resourceOwnerId,
            updates: { metadata_changeset: changeset },
          },
          { onSuccess: onMetadataUpdated, onError },
        )
      }
    />
  );
};
